var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H32V19H24V4Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2338 11.5C24.2338 8.46532 25.7183 5.7736 28 4.03189C26.3231 2.76525 24.2064 2 21.8971 2C16.4261 2 12 6.24855 12 11.5C12 16.7513 16.4261 21 21.8969 21C24.2062 21 26.323 20.2348 28 18.968C25.7183 17.2527 24.2338 14.5347 24.2338 11.5Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 11.5C43.9999 16.7513 39.5738 21 34.103 21C31.7937 21 29.677 20.2348 28 18.968C30.3093 17.2264 31.7663 14.5347 31.7663 11.5C31.7663 8.46532 30.2817 5.7736 28 4.03189C29.6768 2.76525 31.7937 2 34.103 2C39.5738 2 44 6.27499 44 11.5H43.9999Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.53fea436c36f3cb3a470a4e8c92a429c.svg";
export { ForwardRef as ReactComponent };